/* PDP -ugc1 redesign. Gallery thumb-swap + tap-to-zoom, with PDP trust-block
   social proof hydrated from the reviews Worker. Vanilla, no deps. */
(function () {
  'use strict';

  var WORKER = 'https://cakemiami-product-reviews.pavlovacake305.workers.dev';

  function openZoom(src) {
    var z = document.querySelector('.pug-zoom');
    if (!z) {
      z = document.createElement('div');
      z.className = 'pug-zoom';
      z.innerHTML = '<button class="pug-zoom-x" type="button" aria-label="Close">✕</button><img alt="">';
      document.body.appendChild(z);
      z.addEventListener('click', function (e) {
        if (e.target === z || e.target.classList.contains('pug-zoom-x')) z.classList.remove('is-open');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') z.classList.remove('is-open');
      });
    }
    z.querySelector('img').src = src;
    z.classList.add('is-open');
  }

  function setActiveThumb(g, thumb) {
    var hero = g.querySelector('[data-pug-hero]');
    var thumbs = g.querySelectorAll('[data-pug-thumb]');

    if (!hero || !thumb) return;

    var full = thumb.getAttribute('data-full');
    var thumbImg = thumb.querySelector('img');
    var alt = thumb.getAttribute('data-alt') || (thumbImg && thumbImg.getAttribute('alt')) || '';
    if (full) hero.src = full;
    if (alt) hero.alt = alt;
    thumbs.forEach(function (x) { x.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  function initVariantImageSync(g) {
    if (g.dataset.pugVariantSync === 'true') return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    g.dataset.pugVariantSync = 'true';

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      var thumb = findThumbForVariant(g, variant);
      setActiveThumb(g, thumb);
    });
  }

  function initVariantPickerImageSync(g) {
    var picker = document.querySelector('variant-selects');
    if (!picker || g.dataset.pugVariantPickerSync === 'true') return;

    g.dataset.pugVariantPickerSync = 'true';
    picker.addEventListener('change', function () {
      window.setTimeout(function () {
        syncSelectedVariantImage(g);
      }, 50);
    });
  }

  function normalizeMediaUrl(src) {
    if (!src) return '';

    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.delete('width');
      var query = url.searchParams.toString();
      return url.pathname + (query ? '?' + query : '');
    } catch (e) {
      return src.replace(/([?&])width=[^&]*&?/, function (match, separator) {
        return separator === '?' ? '?' : '';
      }).replace(/[?&]$/, '');
    }
  }

  function variantMediaSrc(variant) {
    return variant &&
      variant.featured_media &&
      variant.featured_media.preview_image &&
      variant.featured_media.preview_image.src ||
      variant &&
      variant.featured_image &&
      variant.featured_image.src ||
      '';
  }

  function findThumbForVariant(g, variant) {
    var mediaId = variant && variant.featured_media && variant.featured_media.id;
    var mediaSrc = normalizeMediaUrl(variantMediaSrc(variant));
    var thumb;

    if (mediaId) {
      thumb = g.querySelector('[data-pug-thumb][data-media-id="' + mediaId + '"]');
      if (thumb) return thumb;
    }

    if (!mediaSrc) return null;

    var thumbs = g.querySelectorAll('[data-pug-thumb]');
    for (var i = 0; i < thumbs.length; i += 1) {
      var candidate = normalizeMediaUrl(thumbs[i].getAttribute('data-full') || '');
      if (candidate === mediaSrc) return thumbs[i];
    }

    return null;
  }

  function hasVariantParam() {
    try {
      return new URLSearchParams(window.location.search).has('variant');
    } catch (e) {
      return window.location.search.indexOf('variant=') !== -1;
    }
  }

  function getSelectedVariant() {
    var selectedVariantScript = document.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariantScript) return null;

    try {
      return JSON.parse(selectedVariantScript.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function syncInitialVariantImage(g) {
    if (!hasVariantParam()) return;

    syncSelectedVariantImage(g);
  }

  function syncSelectedVariantImage(g) {
    var thumb = findThumbForVariant(g, getSelectedVariant());
    setActiveThumb(g, thumb);
  }

  function initGallery(g) {
    var hero = g.querySelector('[data-pug-hero]');
    var thumbs = g.querySelectorAll('[data-pug-thumb]');
    if (hero) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          setActiveThumb(g, t);
        });
      });
      hero.addEventListener('click', function () { openZoom(hero.src); });
      initVariantImageSync(g);
      initVariantPickerImageSync(g);
      syncInitialVariantImage(g);
    }
  }

  function normalizeText(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function validMixEntry(entry) {
    return entry &&
      Number(entry.rank) > 0 &&
      normalizeText(entry.option) &&
      normalizeText(entry.value);
  }

  function isFlavorMixEntry(entry) {
    return validMixEntry(entry) && normalizeText(entry.option).toLowerCase() === 'flavor';
  }

  function chooseVariantMix(socialProof) {
    var mix = socialProof && socialProof.variant_mix || {};
    var family = Array.isArray(mix.product_family) ? mix.product_family : [];
    var source = family.filter(isFlavorMixEntry);

    return source.sort(function (a, b) {
      return Number(a.rank) - Number(b.rank);
    }).slice(0, 1);
  }

  function fetchSocialProof(handle) {
    if (!handle || typeof fetch !== 'function') return Promise.resolve(null);

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () { controller.abort(); }, 3000) : null;
    var url = WORKER + '/api/reviews/social-proof?channel=shopify&product=' + encodeURIComponent(handle);

    return fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (response) { return response && response.ok ? response.json() : null; })
      .catch(function () { return null; })
      .then(function (data) {
        if (timeout) clearTimeout(timeout);
        return data;
      });
  }

  function hideVariantMix(row, text) {
    if (text) text.textContent = '';
    if (row) row.hidden = true;
  }

  function initTrust(trust) {
    var gallery = document.querySelector('[data-pug-gallery]');
    var handle = trust.getAttribute('data-pug-handle') || (gallery && gallery.getAttribute('data-pug-handle'));
    var orderText = trust.querySelector('[data-pug-order-proof-text]');
    var fallbackText = orderText ? orderText.textContent : '';
    var variantRow = trust.querySelector('[data-pug-variant-mix]');
    var variantText = trust.querySelector('[data-pug-variant-mix-text]');

    if (!orderText || !variantRow || !variantText) return;
    hideVariantMix(variantRow, variantText);

    fetchSocialProof(handle)
      .then(function (socialProof) {
        var mix = chooseVariantMix(socialProof);

        orderText.textContent = fallbackText;

        if (mix.length === 1) {
          var unitShareLabel = normalizeText(mix[0].unit_share_pct_label);
          variantText.textContent = '🥄 Top flavor: ' + normalizeText(mix[0].value) + (unitShareLabel ? ' (' + unitShareLabel + ')' : '');
          variantRow.hidden = false;
        } else {
          hideVariantMix(variantRow, variantText);
        }
      })
      .catch(function () {
        orderText.textContent = fallbackText;
        hideVariantMix(variantRow, variantText);
      });
  }

  function boot() {
    document.querySelectorAll('[data-pug-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-pug-trust]').forEach(initTrust);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
